import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.pad-start";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";

var _mapState;

// 表格工具
import Sortable from "sortablejs";
import { screenDataAdd } from "@/api/user";
import pickerOption from "@/mixins/module/pickerOption";
import { mapState, mapActions } from "vuex";
import { exchangeRate } from "@/api/dataAll/dataSummary";
export default {
  mixins: [pickerOption],
  data: function data() {
    return {
      tableScrollRight: 0,
      // 横向滚动条位置
      pageFnName: "searchClick",
      myChart: null,
      reqLoading: false,
      currencyClose: false,
      tableData: [],
      searchCurrency: [],
      searchData: {
        game_id: "",
        ad_channel: "",
        // 广告渠道
        ad_placement: "" //广告位置

      },
      hourList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
      markingList: [],
      cellStylekeys: [],
      userTypes: [{
        label: this.$t('add'),
        value: 1
      }, {
        label: this.$t('activeLabel'),
        value: 2
      }],
      isLoop: true,
      exchangeRate: 1,
      queryCurrency: "",
      exchangeUSD: [{
        label: "总收入(越南盾)",
        prop: "exchange",
        isfixed: false,
        tabText: "总收入(越南盾)"
      }],
      exchangeVND: [{
        label: "总收入(美元)",
        prop: "exchange",
        isfixed: false,
        tabText: "总收入(美元)"
      }],
      characterList: [{
        label: "剑",
        value: 1
      }, {
        label: "雷",
        value: 2
      }, {
        label: "冰",
        value: 3
      }]
    };
  },
  activated: function activated() {
    var _this = this;

    this.$nextTick(function () {
      _this.setTableRight(_this.$route.meta.scrollLeft);
    });
  },
  created: function created() {
    this.pageFn = this[this.pageFnName];
  },
  computed: _objectSpread({}, mapState("d2admin", (_mapState = {
    rawData: function rawData(state) {
      return state.serchSelect.rawData;
    },
    productsListAll: function productsListAll(state) {
      return state.serchSelect.productsList;
    }
  }, _defineProperty(_mapState, "productsListAll", function productsListAll(state) {
    return state.serchSelect.productsList;
  }), _defineProperty(_mapState, "storeexchangeRate", function storeexchangeRate(state) {
    return state.system.exchangeRate;
  }), _mapState))),
  methods: {
    isyjfmvnd: function isyjfmvnd() {
      return this.rawData.game_mark.indexOf('yjfm') > -1 && this.defaultData().currency_info == 'VND';
    },
    loopSearch: function loopSearch() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.isLoop = false;
        resolve();
      });
    },
    getexchangeRate: function getexchangeRate() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.queryCurrency = _this3.defaultData().currency_info;

        var today = _this3.$times.theDay();

        if (_this3.queryCurrency == "VND" || _this3.queryCurrency == "USD") {
          if (today != _this3.storeexchangeRate.date || _this3.storeexchangeRate[_this3.queryCurrency] == 1) {
            exchangeRate({
              game_id: _this3.rawData.game_id,
              currency_info: _this3.queryCurrency
            }).then(function (res) {
              if (res.status == 200) {
                _this3.exchangeRate = res.data ? Number(res.data) : 1;

                _this3.$store.commit('d2admin/system/setExchangeRate', {
                  key: _this3.queryCurrency,
                  value: _this3.exchangeRate
                });

                resolve();
              }
            });
          } else {
            _this3.exchangeRate = _this3.storeexchangeRate[_this3.queryCurrency];
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
    searchClickPoints: function searchClickPoints(reqFn) {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var num, time, fitFn, dates, datesList, i, _list, times, list, _i, newFn, qd;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                num = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 10;
                time = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : ['starttime', 'endtime'];
                fitFn = _arguments.length > 3 ? _arguments[3] : undefined;
                _this4.reqLoading = true;
                _this4.isLoop = true;
                dates = _this4.$times.getDayAll(_this4.value2[0], _this4.value2[1]);
                datesList = [];

                for (i = 0; i < dates.length; i += num) {
                  _list = dates.slice(i, i + num);
                  times = {};
                  times[time[0]] = _list[0];
                  times[time[1]] = _list[_list.length - 1];
                  datesList.push(times);
                }

                list = [];
                _i = 0;

              case 10:
                if (!(_i < datesList.length)) {
                  _context.next = 30;
                  break;
                }

                if (!_this4.isLoop) {
                  _context.next = 25;
                  break;
                }

                newFn = fitFn && datesList[_i].starttime == _this4.$times.theDay() ? fitFn : reqFn;
                _context.next = 15;
                return newFn(_objectSpread(_objectSpread(_objectSpread({}, _this4.searchData), datesList[_i]), _this4.defaultData()));

              case 15:
                qd = _context.sent;

                if (!(qd.status == 200 || qd.code == 200)) {
                  _context.next = 21;
                  break;
                }

                list.push(_objectSpread(_objectSpread({}, qd.data), {}, {
                  searchdate: datesList[_i]
                }));

                _this4.searchClick(list);

                _context.next = 23;
                break;

              case 21:
                _this4.reqLoading = false;
                return _context.abrupt("break", 30);

              case 23:
                _context.next = 27;
                break;

              case 25:
                _this4.reqLoading = false;
                return _context.abrupt("break", 30);

              case 27:
                _i++;
                _context.next = 10;
                break;

              case 30:
                _this4.reqLoading = false;

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    //请求默认数据处理
    defaultData: function defaultData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "searchData";
      return {
        currency_info: (this.currencyClose || this.searchCurrency.length) && !this[type].currency_info ? process.env.VUE_APP_HB : this[type].currency_info
      };
    },
    // 横向滚动条监听 数据加载完成后调用
    getTableRight: function getTableRight() {
      var _this5 = this;

      if (this.$refs.tableRef) {
        this.$refs.tableRef.bodyWrapper.addEventListener("scroll", function (res) {
          _this5.$route.meta.scrollLeft = res.target.scrollLeft;
        });
      }
    },
    // 设置竖向滚动条
    setStop: function setStop() {
      var scrollTop = this.$route.meta.scrollTop;
      var content = document.querySelector(".d2-container-full__body");

      if (scrollTop && content) {
        content.scrollTo({
          top: scrollTop,
          behavior: "smooth"
        });
      }
    },
    // 设置横向滚动条
    setTableRight: function setTableRight(tableScrollRight) {
      var _this6 = this;

      if (this.tableData && this.tableData.length) {
        this.$nextTick(function () {
          setTimeout(function () {
            var tableScrollRef = _this6.$el.querySelector(".el-table__body-wrapper");

            tableScrollRef.scrollLeft = tableScrollRight;
            setTimeout(function () {
              _this6.setStop();
            }, 600);
          }, 200);
        });
      }
    },
    // 货币变化监听
    currencyChange: function currencyChange(e) {
      this.currencyClose = e;
    },
    //列拖拽
    columnDropInit: function columnDropInit() {
      var _this7 = this;

      var fiNum = this.searchData.channel == "wxminigame" ? 2 : 0;
      var wrapperColumn = document.querySelector(".el-table__header-wrapper tr");
      this.sortable = Sortable.create(wrapperColumn, {
        animation: 500,
        delay: 0,
        onEnd: function onEnd(event) {
          var tempHableHeader = _toConsumableArray(_this7.sericeArr);

          var temp;
          temp = tempHableHeader[event.oldIndex - fiNum];
          tempHableHeader.splice(event.oldIndex - fiNum, 1);
          tempHableHeader.splice(event.newIndex - fiNum, 0, temp);
          _this7.sericeArr = [];

          _this7.$nextTick(function () {
            _this7.sericeArr = tempHableHeader;
            screenDataAdd({
              data: JSON.stringify(tempHableHeader)
            }); // this.$store.commit("d2admin/serchSelect/setsericeArr", tempHableHeader);
          });
        }
      });
    },
    // 列表
    cellStyle: function cellStyle(_ref) {
      var _this8 = this;

      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;
      var isClass = false;
      var strIndex = column.property.indexOf(',');
      var data = this.markingList.findIndex(function (i) {
        return i.date == row.date;
      }) > -1 ? _objectSpread({}, this.markingList.find(function (i) {
        return i.date == row.date;
      })) : {
        day: -1
      };
      data.day = strIndex > -1 ? Number(data.day) - 1 : data.day;
      Object.keys(row).forEach(function (key) {
        _this8.cellStylekeys.forEach(function (i) {
          if (data.day == key.replace(i, "") && key == (strIndex > -1 ? column.property.split(',')[0] : column.property)) {
            if (rowIndex === rowIndex && columnIndex === columnIndex) {
              isClass = true;
            } else {
              isClass = false;
            }
          }
        });
      });

      if (isClass) {
        return "ondayClass";
      }

      return "";
    },
    // 获取时间间隔
    timeInterval: function timeInterval() {
      var _this9 = this;

      return new Promise(function (resolve, reject) {
        // let list = [];
        // this.tableData.forEach((i) => {
        //   list.push({
        //     date: i.date,
        //     day: this.$times.differenceTime(i.date, new Date()) + 1,
        //   });
        // });
        // this.markingList = list;
        var dayList = _this9.$times.getDayAll(_this9.value2[0], _this9.value2[1]);

        var list = [];
        dayList.forEach(function (i) {
          list.push({
            date: i,
            day: _this9.$times.differenceTime(i, new Date()) + 1
          });
        });
        _this9.markingList = list;
        resolve();
      });
    },
    // let dayList = this.$times.getDayAll(this.value2[0],this.value2[1])
    //   let list = []
    //   dayList.forEach(i=>{
    //       list.push({
    //         date:i,
    //         day:this.$times.differenceTime(i,new Date()) + 1
    //       })
    //   })
    //   this.markingList = list
    // 公用分页
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.pageFn && this.pageFn(1);
    },
    // 组件传值数据处理
    searchChange: function searchChange(e) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'searchData';
      this[e.type] = e.data instanceof Array ? e.data : _objectSpread(_objectSpread({}, this[type]), e.data);
    },
    // 表格提示转化
    renderheader: function renderheader(h, _ref2, desc) {
      var column = _ref2.column,
          $index = _ref2.$index;
      return h("div", {
        style: {
          display: "flex",
          "align-items": "center"
        }
      }, [h("div", {
        style: {
          display: "flex",
          "flex-direction": "column",
          "align-items": "center"
        }
      }, [h("div", {}, column.label.split(".")[0]), h("div", {}, column.label.split(".")[1])]), desc ? h("el-tooltip", {
        props: {
          content: desc,
          placement: "top"
        }
      }, [h("span", {
        // style: {
        //   'margin-left': '4px',
        // },
        class: {
          "el-icon-question": true
        }
      })]) : ""]);
    },
    // 储存数据前转换
    dataConvert: function dataConvert() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'searchData';
      var defType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var defD = defType ? this.defaultData() : {};

      var data = _objectSpread(_objectSpread({}, this[type]), defD);

      var str = '_';

      for (var k in data) {
        if (data[k]) {
          if (Array.prototype.isPrototypeOf(data[k]) && !data[k].length) {
            if (data[k].toString()) {
              str = str + data[k].toString() + '_';
            }
          } else {
            str = str + data[k] + '_';
          }
        }
      }

      if (str) {
        str = str.substring(0, str.length - 1);
      }

      return str;
    },
    timestampToDateTime: function timestampToDateTime(timestamp) {
      // 如果时间戳是秒级，乘以1000转换为毫秒
      var date = new Date(timestamp * 1000 || timestamp);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    searchClickLoop: function searchClickLoop(reqFn) {
      var _arguments2 = arguments,
          _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var num, time, dates, datesList, i, _list2, times, list, _i2, qd;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                num = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : 10;
                time = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : ['date'];
                _this10.reqLoading = true;
                _this10.isLoop = true;
                dates = _this10.$times.getDayAll(_this10.value2[0], _this10.value2[1]);
                datesList = [];

                for (i = 0; i < dates.length; i += num) {
                  _list2 = dates.slice(i, i + num);
                  times = {};
                  times[time[0]] = _list2[0]; // times[time[1]] = list[list.length - 1]

                  datesList.push(times);
                }

                list = [];
                _i2 = 0;

              case 9:
                if (!(_i2 < datesList.length)) {
                  _context2.next = 28;
                  break;
                }

                if (!_this10.isLoop) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 13;
                return reqFn(_objectSpread(_objectSpread(_objectSpread({}, _this10.searchData), datesList[_i2]), _this10.defaultData()));

              case 13:
                qd = _context2.sent;

                if (!(qd.status == 200 || qd.code == 200)) {
                  _context2.next = 19;
                  break;
                }

                list.push(_objectSpread({}, qd.data));

                _this10.searchClickNew(list);

                _context2.next = 21;
                break;

              case 19:
                _this10.reqLoading = false;
                return _context2.abrupt("break", 28);

              case 21:
                _context2.next = 25;
                break;

              case 23:
                _this10.reqLoading = false;
                return _context2.abrupt("break", 28);

              case 25:
                _i2++;
                _context2.next = 9;
                break;

              case 28:
                _this10.reqLoading = false;

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};